// extracted by mini-css-extract-plugin
module.exports = {"timeWrapper":"styles_timeWrapper__y_zA8","timer":"styles_timer__oPvTl"};